export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const clientAuthTokenCookieKey = "tkktAuK";
export const adminAuthTokenCookieKey = "adTkktAuK";
export const clientProfileCookieKey = "tkktPK";
export const adminProfileCookieKey = "adTkktPK";
export const welcomeModalKey = "isWelcomeModalShown";
export const OTPMAXTIME = 90;
export const MAX_SIZE_MB = 2 * 1024 * 1024;
export const CLOUDINARY_URL = process.env.REACT_APP_CLOUDINARY_URL;
export const CLOUDINARY_PRESET = "tikket_preset";
export const PRIMARY_COLOR = "#04000A";
export const DEFAULT_EVENT_IMAGE_URL =
  "http://res.cloudinary.com/kneenk/image/upload/v1741163355/tikket_uploads/mw16ijeje8drvsbrrvcj.jpg";
export const WARNING_TICKET_QUANTITY = 10;
export const MAX_PURCHASE_QUANTITY = 5;
export const FEE_PERCENTAGE = 0.05;
export const FEE_PERCENTAGE_TEXT = `${FEE_PERCENTAGE * 100}% + ₦100`;
export const SKELETON_BASE_COLOR = "#f4f7fa";
export const SKELETON_HIGHLIGHT_COLOR = "#ffffff";
export const TICKET_COLOR_OPTIONS = [
  "#65007f,#f9eafd",
  "#2051CA,#F0F6FF",
  "#BE0606,#FDF2F2",
  "#CB8E00,#FFF6D6",
  "#008035,#D8F6E4",
  "#697BA7,#F4F7FA",
]; //i.e ["#pillTextColor,#pillBgColor"]
export const guestEventsLSKey = "guestEvents";
export const guestProfileLSKey = "guestProfile";
export const paidTooltip = {
  id: "paid-tooltip",
  text: "This is the total amount we’ve paid into your payout account.",
};
export const pendingPayoutTooltip = {
  id: "pending-payout-tooltip",
  text: `This is how much you’ve made that hasn’t been paid into your payout account.\nN.B. Payouts that fall on weekends and public holidays would be paid the next working day.`,
};
export const APP_SUBDOMAIN_PREFIX = "app.";

export const domain = window.location.hostname;

/**
 * A constant that determines whether a subdomain should not be used.
 * This is based on the condition that the domain is not "tikket.online".
 */
export const shouldNotUseSubDomain =
  // domain.startsWith("localhost") ||
  // domain.startsWith("192") ||
  // domain.includes("vercel.app")||
  domain !== "tikket.online";
